import "@hotwired/turbo-rails"
require("../stimulus");
require("../pwa");
require("../game_drill");

import TurboPower from 'turbo_power'
TurboPower.initialize(Turbo.StreamActions)
